<template>
<div>



   <section class="pa-9">
      <article>
         <!-- video 1 in series -->
         <h1>  時代の夢	  </h1>
         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/3D-ZUMcfFfA" frameborder="0" allowfullscreen></iframe>
         </div>

      </article>


      <article>
         <!-- video 2 in series -->
         <h1>  王の再臨  </h1>
         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/Csr5_7IlTTA" frameborder="0" allowfullscreen></iframe>
         </div>

      </article>


      <article>
         <!-- video 3 in series -->
         <h1>  - 高慢な王子   </h1>
         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/VRT8umx4qaA" frameborder="0" allowfullscreen></iframe>
         </div>

      </article>



      <article>
         <!-- video 4 in series -->
         <h1>  最大の犠牲|   </h1>
         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/SSwgs2bbb_o" frameborder="0" allowfullscreen></iframe>
         </div>

      </article>



      <article>
         <!-- video 5 in series -->
         <h1>  悪魔の牢獄  </h1>
         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/b80pe1uN1XU" frameborder="0" allowfullscreen></iframe>
         </div>

      </article>


      <article>
         <!-- video 6 in series -->
         <h1>  不変の律法   </h1>
         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/8fc64AU_7G0" frameborder="0" allowfullscreen></iframe>
         </div>

      </article>


      <article>
         <!-- video 7 in series -->
         <h1>  私たちの労働の休息   </h1>
         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/6gyzYh_0K_w" frameborder="0" allowfullscreen></iframe>
         </div>

      </article>


      <article>
         <!-- video 8 in series -->
         <h1>  最も裕福な洞穴男   </h1>
         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/RsCuXGD5ddM" frameborder="0" allowfullscreen></iframe>
         </div>

      </article>

      <article>
         <!-- video 9 in series -->
         <h1>  惑わしの霊   </h1>
         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/uB1kYE_-WUg" frameborder="0" allowfullscreen></iframe>
         </div>
      </article>


      <article>
         <!-- video 10 in series -->
         <h1>  最後の火の嵐  </h1>
         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/tAdyo5Q7OZs" frameborder="0" allowfullscreen></iframe>
         </div>
      </article>

      <article>
         <!-- video 11 in series -->
         <h1>  聖所の清め   </h1>
         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/JKtK7QUB5NE" frameborder="0" allowfullscreen></iframe>
         </div>
      </article>

      <article>
         <!-- video 12 in series -->
         <h1>  豪華の王国    </h1>
         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/mR2wSBFSres" frameborder="0" allowfullscreen></iframe>
         </div>
      </article>



      <article>
         <!-- video 13 in series -->
         <h1>  川で生まれる   </h1>
         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/mMYRncNAuE4" frameborder="0" allowfullscreen></iframe>
         </div>
      </article>


      <article>
         <!-- video 14 in series -->
         <h1>  獣に矢を射る   </h1>
         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/l0it-NbpGsU" frameborder="0" allowfullscreen></iframe>
         </div>
      </article>



      <article>
         <!-- video 15 in series -->
         <h1>  死の印を受ける   </h1>
         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/ICpt8XouObU" frameborder="0" allowfullscreen></iframe>
         </div>
      </article>

      <article>
         <!-- video 16 in series -->
         <h1>  真理の女性  </h1>
         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/uoam74E_7nA" frameborder="0" allowfullscreen></iframe>
         </div>
      </article>


      <article>
         <!-- video 17 in series -->
         <h1>  娘の恐怖の踊り  </h1>
         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/4GDcXSGs7i8" frameborder="0" allowfullscreen></iframe>
         </div>
      </article>

      <article>
         <!-- video 18 in series -->
         <h1>  バビロンの宴会  </h1>
         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/FT69Lnb64fg" frameborder="0" allowfullscreen></iframe>
         </div>
      </article>

      <article>
         <!-- video 19 in series -->
         <h1>  王の大使  </h1>
         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/Q9qPmLAuIu8" frameborder="0" allowfullscreen></iframe>
         </div>
      </article>


      <article>
         <!-- video 20 in series -->
         <h1> 真理と偽りの預言者  </h1>
         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/wXoka5UN_mQ" frameborder="0" allowfullscreen></iframe>
         </div>
      </article>


   </section>


</div>
</template>

<script>



export default {
name: "landmarkProphecy",
   components: { },
}
</script>

<style scoped>
article{
    margin-bottom: 50px;
}
</style>
